import {
  BeListApiSetWelcomeMessage
} from 'Api/BeListApi'

import { beListApiGetListsLazy } from 'Api/beListApiTS'

import {
  beMessAddBeeTemplateToList,
  beMessApiAddConcurrentAccess,
  beMessApiCreateMessage,
  beMessApiDeleteConcurrentAccess,
  beMessApiGetBeePluginUid,
  beMessApiGetConcurrentAccess,
  beMessApiGetDynamicContentByList,
  beMessApiSetActiveMessageOfType,
  beMessApiUpdateConcurrentAccess,
  beMessApiUpdateMessage,
  beMessCheckCompliantHtmlMessageType,
  beMessCheckSetMessageTypes,
  beMessCopyBeeTemplateToLists,
  beMessDeleteMessageAutoSave,
  beMessGetBeeCentralizedEmailTemplateDetails,
  beMessGetBeeTemplateDetails,
  beMessGetBeeTemplates,
  beMessGetMessageAutoSave,
  beMessGetMessageDetails,
  beMessSetMessageAutoSave,
} from 'Api/BeMessApi'
import {
  beAccountSettimgsApiGetAccountLimits,
  beAccountSettingsGetUserSetting,
  beAccountSettingsUpsertUserSettings,
} from 'Api/beAccountSettingsApi'
import { beAccountsApiGetUserById } from 'Api/beAccountsApi'
import {
  beAutomationApiSearchWorkflowByTypeAndStatus,
  beAutomationApiUpdateWelcomeSeries,
} from 'Api/beAutomationApi'
import {
  beFiltersGetAllLiquidProfileFilters,
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters,
} from 'Api/beFiltersApi'
import { beFormListAutoprofileForms } from 'Api/beFormApi'
import { bePubCustomListLandingPages } from 'Api/bePubCustomApi'
import {
  CHANNEL_TYPE_EMAIL,
  GROUPS_SEARCH_TYPE_ECONTAINS,
  GROUPS_SEARCH_TYPE_EQUALTO,
  SUBSCRIPTION_TYPE_SUBSCRIBED,
  beRecipientGetDynamicFieldsDefinition,
  beRecipientGetListOfGroupDetails,
  beRecipientGetRecipient,
  beRecipientSearchForRecipients,
} from 'Api/beRecipientApi'
import { beeParserApiGetHTMLFromStructure } from 'Api/beeParserApi'
import { BEE_FONTS, LOGIN_TYPE_WEBLOGIN } from 'Constants/'
import {
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  MESSAGE_AUTOSAVE_TIMEOUT,
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_WELCOME,
  WORKFLOW_STR_STATUS_ALL,
  WORKFLOW_STR_TYPE_WELCOME_SERIES,
} from 'Constants/index'
import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { pendoTrack } from 'Helpers/pendoTracking'
import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  STORE_KEY_LOGIN_TYPE,
  STORE_KEY_USER,
  evalCondition,
  getLang,
  storeGet,
} from 'mailup-react-helpers'

import { beEmailMessageApiListDynamicContentByIdMessage } from 'Api/beEmailMessageApi'
import { beEmailRenderingApiGeneratePreview } from 'Api/beEmailRenderingApi'
import {
  bePersonalizationApiGetListActivation,
  bePersonalizationApiGetMessageActivation,
} from 'Api/bePersonalizationApi'

import {
  beBeeServiceApiAuthorizeBee,
  beBeeServiceGetContentDefaults,
  beBeeServiceGetUsedTokens,
  beBeeServiceStoreUsedTokens,
} from 'Api/beBeeServiceApi'
import { TOAST_VARIANT_WARNING, toastShow } from 'mailup-web-components'
import transformations from '../../../../components/PreviewTool/transformations'

export async function getThirdPartyAccepted() {
  const result = await beAccountSettingsGetUserSetting(
    0,
    'thirdPartyResourceAlert',
  )
  return result && result.DataValue === '1'
}

export async function setThirdPartyResourceAlert() {
  try {
    const result = await beAccountSettingsUpsertUserSettings(
      0,
      'thirdPartyResourceAlert',
      1,
    )
    return !result || result?.DataValue !== '1'
  } catch (error) {
    logAppError({
      appError: error,
    })
  }
}

export async function getTargetLists(disabledList) {
  const { Items } = await beListApiGetListsLazy({
    force: true,
    pageSize: 0,
    pageNumber: 0,
    orderBy: 'Id',
    orderDescending: false,
  })

  return Items.map(({ IdList, Name }) => ({
    value: IdList,
    label: `${IdList} - ${Name}`,
    disabled: disabledList.indexOf(IdList) !== -1,
  }))
}

export const getMessageDetails = beMessGetMessageDetails

export function updatePreviewReferenceRecipient(dataValue) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beAccountSettingsUpsertUserSettings(
    idList,
    'previewReferenceRecipient',
    dataValue,
  )
  return result || {}
}

export async function getConcurrentAccessUser(idMessage) {
  if (!idMessage || Number.parseInt(idMessage) === 0) {
    return undefined
  }

  const users = await beMessApiGetConcurrentAccess(
    idMessage,
    MESSAGE_AUTOSAVE_TIMEOUT,
  )

  const { Id: idCurrentUser } = storeGet(STORE_KEY_USER)
  const others = users.filter(({ IdUser }) => IdUser !== idCurrentUser)

  if (!others.length) {
    return undefined
  }

  const { Username } = await beAccountsApiGetUserById(others[0].IdUser)

  return Username
}

export async function deleteConcurrentAccess(idMessage) {
  if (Number.parseInt(idMessage) === 0) {
    return true
  }

  const result = await beMessApiDeleteConcurrentAccess(idMessage)
  return result
}

export async function deleteAllConcurrentAccess(idMessage) {
  if (Number.parseInt(idMessage) === 0) {
    return true
  }

  const result = await beMessApiDeleteConcurrentAccess(idMessage, true)
  return result
}

export async function insertConcurrentAccess(idMessage) {
  if (Number.parseInt(idMessage) === 0) {
    return true
  }

  const result = await beMessApiAddConcurrentAccess(idMessage)
  return result
}

export async function updateConcurrentAccess(idMessage) {
  if (Number.parseInt(idMessage) === 0) {
    return true
  }

  const result = await beMessApiUpdateConcurrentAccess(idMessage)
  return result
}

export async function getMessageAutoSave(idMessage) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beMessGetMessageAutoSave(idList, idMessage)
  return result
}

export const getBeeMessageToken = () => beBeeServiceApiAuthorizeBee('message')

export async function deleteAutosave(idMessage) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  try {
    await beMessDeleteMessageAutoSave(idList, idMessage)
  } catch (error) {
    logAppError({ appError: error })
  }
}

export async function copyTemplate(id, title, lists) {
  const result = await beMessCopyBeeTemplateToLists({ id, title, lists })

  return result
}

export async function addTemplate(idList, data) {
  const result = await beMessAddBeeTemplateToList(idList, data)
  return result
}

export const sortDisplayConditions = (
  { level1Compare: l1A, level2Compare: l2A },
  { level1Compare: l1B, level2Compare: l2B },
) => {
  return l1A < l1B ? -1 : l1A > l1B ? 1 : l2A < l2B ? -1 : l2A > l2B ? 1 : 0
}

export const getRoleHash = (lockContentBeeEditor, enableDisplayConditions) => {
  return lockContentBeeEditor
    ? enableDisplayConditions
      ? 'LockRowsPersonalization'
      : 'LockRows'
    : enableDisplayConditions
      ? 'Personalization'
      : 'NoLockRowsNoPersonalization'
}

export async function fetchDynamicContents() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beMessApiGetDynamicContentByList(idList)

  return [
    ...Items.map(({ Id, Name }) => ({
      value: `[*Cnt_${Id}_${Name}*]`,
      name: Name,
    })),
  ]
}

export async function fetchMergeTags() {
  const fields = await beRecipientGetDynamicFieldsDefinition({
    isdynamic: true,
  })

  const specialFields = [
    'email',
    'prefix',
    'number',
    '_subemail',
    '_subsms',
    '_idnl',
    '_hash',
    '_idoptin',
    'idu',
    '_ip_req_sub',
    '_ip_conf_sub',
    '_idlist',
    '_mandatory_sender_info_company',
    '_mandatory_sender_info_contact',
    '_mandatory_sender_info_address',
    '_mandatory_sender_info_city',
    '_mandatory_sender_info_state',
    '_mandatory_sender_info_postalcode',
    '_mandatory_sender_info_country',
    '_mandatory_sender_info_phone',
    '_mandatory_sender_info_website',
    '_mandatory_sender_info_permission_reminder',
    '_currentday',
    '_currentdayname',
    '_currentmonth',
    '_currentmonthname',
    '_currentyear',
  ]

  const mergeTags = [
    ...fields
      .map(({ Description }) => Description.toLowerCase())
      .sort((a, b) => (a < b ? -1 : a > b ? 1 : 0))
      .map((f) => ({
        value: `[${f}]`,
        name: f,
      })),
    ...specialFields.map((f) => ({
      value: `[${f}]`,
      name: f,
    })),
  ]

  return mergeTags
}

export async function fetchRowDisplayConditions() {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const items = await beFiltersGetAllLiquidProfileFilters(idList)
  const categories = await beFiltersGetListOfCategories(0, 0)
  const categoriesMap = categories.Items.reduce(
    (acc, { Id, Name }) => {
      return {
        ...acc,
        [Id]: Name,
      }
    },
    { 0: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' }) },
  )

  const result = items.map(
    ({ IdCategory, Name, Description, LiquidBegin, LiquidEnd }) => ({
      type: categoriesMap[IdCategory],
      label: Name,
      description: Description,
      before: LiquidBegin,
      after: LiquidEnd,
      level1Compare: categoriesMap[IdCategory]?.toLowerCase(),
      level2Compare: Name.toLowerCase(),
    }),
  )

  return result.sort(sortDisplayConditions)
}

export async function fetchSpecialLinks() {
  const intl = getIntl()
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const { IdList, Guid } = storeGet(STORE_KEY_LIST)
  const commonType = intl.formatMessage({
    id: 'Load.Bee.SpecialLinkTypeCommon',
  })
  const archiveType = intl.formatMessage({
    id: 'Load.Bee.SpecialLinkTypeArchivedNewsletters',
  })

  const autoprofileForms = await fetchAutoprofileForms()
  const landingPages = await fetchLandingPages()

  return [
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkUnsubscribe' }),
      link: 'http://[unsubscribe]/',
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkConfirmSubscribe' }),
      link: 'http://[subscribelink]/',
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkPreferenceCenter' }),
      link: 'http://[prefcenter]/',
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkShowInBrowser' }),
      link: 'http://[staticnl]/',
    },
    {
      type: commonType,
      label: intl.formatMessage({ id: 'Load.Bee.SpecialLinkSendToAFriend' }),
      link: `https://${Domain}/frontend/sendtoafriend.aspx?idNL=[_idnl]&idoptin=[_idoptin]&strHash=[_hash]`,
    },
    ...autoprofileForms,
    ...landingPages,
    {
      type: archiveType,
      label: intl.formatMessage({
        id: 'Load.Bee.SpecialLinkArchivedNewsletterCatalogForCurrentList',
      }),
      link: `http://${Domain}/frontend/newsletters.aspx?idlist=${IdList}&hashlista=${encodeURIComponent(
        Guid,
      )}#`,
    },
    {
      type: archiveType,
      label: intl.formatMessage({
        id: 'Load.Bee.SpecialLinkArchivedNewsletterCatalogForConsole',
      }),
      link: `http://${Domain}/frontend/nl_catalog.aspx`,
    },
  ]
}

export const getBeeLang = (lang) => {
  switch (lang.toLowerCase()) {
    case 'en':
      return 'en-US'
    case 'ja':
      return 'ja-JP'
    case 'hi':
      return 'hi-IN'
    case 'pt':
      return 'pt-BR'
    case 'da':
      return 'da-DK'
    default:
      return `${lang.toLowerCase()}-${lang.toUpperCase()}`
  }
}

export async function fetchAutoprofileForms() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const items = await beFormListAutoprofileForms(idList, {
    pageNumber: 0,
    pageSize: 0,
    enabled: true,
  })

  const type = getIntl().formatMessage({
    id: 'Load.Bee.SpecialLinkTypeAutoprofileForms',
  })

  return items.Items.map(({ Id, Name }) => ({
    type,
    label: Name,
    link: `http://[autoprofile]/&idForm=${Id}`,
  }))
}

export async function fetchLandingPages() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const { Guid } = storeGet(STORE_KEY_LIST)
  const { Items } = await bePubCustomListLandingPages(idList, {
    pageNumber: 0,
    pageSize: 0,
  })

  const type = getIntl().formatMessage({
    id: 'Load.Bee.SpecialLinkTypeLandingPages',
  })

  return Items !== null
    ? Items.filter(({ Status }) => Status).map(({ Id, Name }) => ({
        type,
        label: Name,
        link: `http://${Domain}/frontend/LandingPage.aspx?idList=${idList}&idLP=${Id}&guid=${encodeURIComponent(
          Guid,
        )}`,
      }))
    : []
}

export async function getBeePluginConfig() {
  const lang = getLang()

  const language = getBeeLang(lang)
  const lockContentBeeEditor = evalCondition('uo:LOCKCONTENTBEEEDITOR')

  const enableDisplayConditions = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION',
  )

  const hasDynamicFields = evalCondition('uo:DYNFLD')

  const roleHash = getRoleHash(lockContentBeeEditor, enableDisplayConditions)

  const idList = storeGet(STORE_KEY_ID_LIST)

  const uid = await beMessApiGetBeePluginUid(idList)

  const specialLinks = await fetchSpecialLinks()

  const mergeTags = hasDynamicFields ? await fetchMergeTags() : []

  const mergeContents = hasDynamicFields ? await fetchDynamicContents() : []

  const rowDisplayConditions = enableDisplayConditions
    ? await fetchRowDisplayConditions()
    : []

  const account = storeGet(STORE_KEY_ACCOUNT)

  const beeSavedRowsEnabled = account.IdOffer !== 3 && !account.IsOfferLight // NON E' UNA STARTER - LIGHT
  const beeEditSavedRowsEnabled =
    account.IdOffer !== 3 && account.IdOffer !== 2 && !account.IsOfferLight // NON E' UNA STARTER - FREQUENZA -LIGHT

  const beeAIAssistantOption = evalCondition('co:BEEMSGAIASSISTANT')
  const beeAIAssistantEnabled = beeAIAssistantOption

  const advancedPermissions = {
    content: {
      paragraph: {
        behaviors: {
          canViewSidebar: true,
        },
        properties: {
          aiIntegration: {
            show: beeAIAssistantEnabled,
            locked: false,
          },
        },
      },
      button: {
        behaviors: {
          canSelect: true,
          canAdd: true,
          canViewSidebar: true,
          canClone: true,
          canMove: true,
          canDelete: true,
          canResetMobile: false,
        },
        properties: {
          aiIntegration: {
            show: beeAIAssistantEnabled,
            locked: false,
          },
        },
      },
      title: {
        behaviors: {
          canSelect: true,
          canAdd: true,
          canViewSidebar: true,
          canClone: true,
          canMove: true,
          canDelete: true,
          canResetMobile: false,
        },
        properties: {
          aiIntegration: {
            show: beeAIAssistantEnabled,
            locked: false,
          },
        },
      },
      list: {
        properties: {
          aiIntegration: {
            show: beeAIAssistantEnabled,
            locked: false,
          },
        },
      },
    },
  }

  const replaceCurlyBrackets = (str) => {
    return str.replace('{', '[').replace('}', ']')
  }

  let respAIInfo = {
    TotalTokens: 0,
    RemainingTokens: 0,
    EnableUse: false,
    ShowBuy: false,
  }
  if (beeAIAssistantEnabled) {
    try {
      respAIInfo = await beBeeServiceGetUsedTokens()
    } catch (error) {
      toastShow(
        getIntl().formatMessage({ id: 'Load.Bee.AiNotAvailable' }),
        TOAST_VARIANT_WARNING,
        'saveSenderInfoError',
      )
      logAppError({
        appError: error,
        Component: 'MessageEdit',
        Method: 'beBeeServiceGetUsedTokens',
      })
    }
  }

  const showMshop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP',
  )

  const setWelecomeHeadingTitle = () => {
    let text = ''
    if (respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeHeadingExampleActiveBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeHeadingExampleActiveBtnNoMshop',
        })
      }
    }
    if (respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeHeadingExampleActiveNoBtn',
      })
    }
    if (!respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtnNoMshop',
        })
      }
    }
    if (!respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeExampleDisableNoBtn',
      })
    }

    text = text.split('{').join('[')
    text = text.split('}').join(']')

    return text
  }

  const setWelecomeHeadingList = () => {
    let text = ''
    if (respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeListExampleActiveBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeListExampleActiveBtnNoMshop',
        })
      }
    }
    if (respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeListExampleActiveNoBtn',
      })
    }
    if (!respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtnNoMshop',
        })
      }
    }
    if (!respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeExampleDisableNoBtn',
      })
    }

    text = text.split('{').join('[')
    text = text.split('}').join(']')
    return text
  }

  const setWelecomeHeadingParagraph = () => {
    let text = ''
    if (respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeParagraphExampleActiveBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeParagraphExampleActiveBtnNoMshop',
        })
      }
    }
    if (respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeParagraphExampleActiveNoBtn',
      })
    }
    if (!respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtnNoMshop',
        })
      }
    }
    if (!respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeExampleDisableNoBtn',
      })
    }

    text = text.split('{').join('[')
    text = text.split('}').join(']')
    return text
  }

  const setWelecomeHeadingButton = () => {
    let text = ''
    if (respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeButtonExampleAtiveBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeButtonExampleAtiveBtnNoMshop',
        })
      }
    }
    if (respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeButtonExampleAtiveNoBtn',
      })
    }
    if (!respAIInfo.EnableUse && respAIInfo.ShowBuy) {
      if (showMshop) {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtn',
        })
      } else {
        text = getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeExampleDisableBtnNoMshop',
        })
      }
    }
    if (!respAIInfo.EnableUse && !respAIInfo.ShowBuy) {
      text = getIntl().formatMessage({
        id: 'Load.Bee.AiWelcomeExampleDisableNoBtn',
      })
    }

    text = text.split('{').join('[')
    text = text.split('}').join(']')
    return text
  }

  const beeConfiguration = {
    // whitelabel: true, // Not implemented yet
    // mode: 'full', // 'full|advanced|basic|view', // Not implemented yet
    // theme: 'classic', //'dark|light|classic', // Not implemented yet
    // showToolbar: true,
    // toolbar: ['Save', 'Save As Template', 'Send', 'Preview'], // Not implemented yet,
    uid,
    addOns: [],
    container: 'bee-plugin-container',
    autosave: 30, // in seconds - Utils.CInt(Utils.GetCommonSetting("NewsletterAutoSaveTimeout"), 60);
    language: language, // if language is not supported the defualt language is loaded (value must have two-letter ISO 639-1 code format)
    specialLinks: specialLinks,
    mergeTags: mergeTags,
    mergeContents: mergeContents,
    preventClose: false,
    rowDisplayConditions: rowDisplayConditions,
    rowsConfiguration: {
      emptyRows: true,
      defaultRows: true,
      externalContentURLs: [],
    },
    contentDialog: {},
    roleHash,
    trackChanges: true,
    editorFonts: {
      showDefaultFonts: false,
      customFonts: BEE_FONTS,
    },
    saveRows: beeSavedRowsEnabled,
    commenting: false,
    translations: {
      'mailup-bee-rows-management': {
        edit: getIntl().formatMessage({ id: 'Load.MailupCommon.Edit' }),
      },
      'mailup-bee-common-component-ai': {
        'welcome-body-title': getIntl().formatMessage({
          id: respAIInfo.EnableUse
            ? 'Load.Bee.AiWelcomeBodyTitle'
            : 'Load.Bee.AiWelcomeBodyTitleNoTk',
        }),
        'welcome-example': setWelecomeHeadingParagraph(),
        'welcome-body-subtitle': respAIInfo.EnableUse
          ? getIntl().formatMessage({
              id: 'Load.Bee.AiWelcomeBodySubtitle',
            })
          : '<p></p>',
        'welcome-header-title': getIntl().formatMessage({
          id: 'Load.Bee.AiWelcomeHeaderTitle',
        }),
        placeholder: getIntl().formatMessage({
          id: 'Load.Bee.AiPlaceholder',
        }),
        'clear-results': getIntl().formatMessage({
          id: 'Load.Bee.AiClearResults',
        }),
        generate: getIntl().formatMessage({
          id: 'Load.Bee.Generate',
        }),
        'error-title': getIntl().formatMessage({
          id: 'Load.Bee.AiErrorTitle',
        }),
        'error-subtitle': getIntl().formatMessage({
          id: 'Load.Bee.AiErrorSubitle',
        }),
        'config-label': getIntl().formatMessage({
          id: 'Load.Bee.AiConfigLabel',
        }),
        'mailup-common-image-editor': getIntl().formatMessage({
          id: 'Load.Bee.MailupCommonImageEditor',
        }),
        ai: getIntl().formatMessage({
          id: 'Load.Bee.AiSpell',
        }),
        'token-usage': getIntl().formatMessage({
          id: 'Load.Bee.AiTokenUsage',
        }),
        'pin-label': getIntl().formatMessage({
          id: 'Load.Bee.AiPinLabel',
        }),
        restart: getIntl().formatMessage({
          id: 'Load.Bee.AiRestart',
        }),
        'header-title': getIntl().formatMessage({
          id: 'Load.Bee.AiHeaderTitle',
        }),
        'welcome-heading-title': getIntl().formatMessage({
          id: respAIInfo.EnableUse
            ? 'Load.Bee.AiWelcomeHeadingTitle'
            : 'Load.Bee.AiWelcomeHeadingTitleNoTk',
        }),
        'welcome-heading-subtitle': respAIInfo.EnableUse
          ? getIntl().formatMessage({
              id: 'Load.Bee.AiWelcomeHeadingSubtitle',
            })
          : '<p></p>',
        'welcome-heading-example': setWelecomeHeadingTitle(),
        'welcome-list-title': getIntl().formatMessage({
          id: respAIInfo.EnableUse
            ? 'Load.Bee.AiWelcomeListTitle'
            : 'Load.Bee.AiWelcomeListTitleNoTk',
        }),
        'welcome-list-subtitle': respAIInfo.EnableUse
          ? getIntl().formatMessage({
              id: 'Load.Bee.AiWelcomeListSubtitle',
            })
          : '<p></p>',
        'welcome-list-example': setWelecomeHeadingList(),
        'welcome-button-title': getIntl().formatMessage({
          id: respAIInfo.EnableUse
            ? 'Load.Bee.AiWelcomeButtonTitle'
            : 'Load.Bee.AiWelcomeButtonTitleNoTk',
        }),
        'welcome-button-subtitle': respAIInfo.EnableUse
          ? getIntl().formatMessage({
              id: 'Load.Bee.AiWelcomeButtonSubtitle',
            })
          : '<p></p>',
        'welcome-button-example': setWelecomeHeadingButton(),
        'suggest-check-spelling': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestCheckSpelling',
        }),
        'suggest-correct-grammar': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestCorrectGrammar',
        }),
        'suggest-summarize-text': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestSummarizeText',
        }),
        'suggest-use-active-voice': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestUseActiveVoice',
        }),
        'suggest-convert-third-person': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestConvertThirdPerson',
        }),
        'suggest-translate': replaceCurlyBrackets(
          getIntl().formatMessage({
            id: 'Load.Bee.AiSuggestTranslate',
          }),
        ),
        'suggest-capitalize-text': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestCapitalizeText',
        }),
        'suggest-adjust-tone': replaceCurlyBrackets(
          getIntl().formatMessage({
            id: 'Load.Bee.AiSuggestAdjustTone',
          }),
        ),
        'suggest-translate-button': replaceCurlyBrackets(
          getIntl().formatMessage({
            id: 'Load.Bee.AiSuggestTranslateButton',
          }),
        ),
        'suggest-make-it-tone': replaceCurlyBrackets(
          getIntl().formatMessage({
            id: 'Load.Bee.AiSuggestMakeItTone',
          }),
        ),
        'suggest-correct-grammar-list': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestCorrectGrammarList',
        }),
        'suggest-capitalize-all-words': getIntl().formatMessage({
          id: 'Load.Bee.AiSuggestCapitalizeAllWords',
        }),
        'suggest-characters-length': replaceCurlyBrackets(
          getIntl().formatMessage({
            id: 'Load.Bee.AiSuggestCharactersLenght',
          }),
        ),
        'suggest-translate-heading': replaceCurlyBrackets(
          getIntl().formatMessage({ id: 'Load.Bee.AiSuggestTranslateHeading' }),
        ),
      },
    },
    advancedPermissions: advancedPermissions,
  }
  if (beeAIAssistantEnabled) {
    beeConfiguration.addOns.push({
      id: 'ai-integration',
      // settings: {
      //   tokensAvailable: respAIInfo.ShowBuy
      //     ? respAIInfo.TotalTokens
      //     : undefined,
      //   tokensUsed: respAIInfo.ShowBuy
      //     ? respAIInfo.TotalTokens - respAIInfo.RemainingTokens
      //     : undefined,
      //   tokenLabel: respAIInfo.ShowBuy
      //     ? getIntl().formatMessage({
      //         id: 'Load.Bee.Tokens'
      //       })
      //     : '',
      //   isPromptDisabled: !respAIInfo.EnableUse
      // }

      settings: {
        tokensAvailable: respAIInfo.TotalTokens,
        tokensUsed: respAIInfo.TotalTokens - respAIInfo.RemainingTokens,
        tokenLabel: getIntl().formatMessage({
          id: 'Load.Bee.Tokens',
        }),
        isPromptDisabled: !respAIInfo.EnableUse,
      },
    })
  }

  if (beeSavedRowsEnabled) {
    beeConfiguration.rowsConfiguration.externalContentURLs.push({
      name: getIntl().formatMessage({ id: 'Load.Bee.SavedRows' }),
      value: 'category-value',
      handle: 'category-handle',
      isLocal: true,
      behaviors: {
        canEdit: beeEditSavedRowsEnabled,
        canDelete: true,
      },
    })
  }
  let contentDefaults = null

  try {
    contentDefaults = await beBeeServiceGetContentDefaults(idList)
  } catch (error) {
    toastShow(
      getIntl().formatMessage({ id: 'Load.Bee.ContentDefaultsNotAvailable' }),
      TOAST_VARIANT_WARNING,
      'ContentDefaultsNotAvailable',
    )
    logAppError({
      appError: error,
    })
  }

  if (
    contentDefaults &&
    contentDefaults.Enable &&
    contentDefaults.Configuration
  ) {
    const enableObj = JSON.parse(contentDefaults.Enable)
    const configurationObj = JSON.parse(contentDefaults.Configuration)
    if (enableObj && enableObj.EnableAll && configurationObj) {
      beeConfiguration.contentDefaults = configurationObj
    }
  }
  return beeConfiguration
}

export async function getDynamicFieldsWhitelist(entityType, id) {
  const allowedEntityTypes = ['TPL', 'NL', 'CMP']
  if (!allowedEntityTypes.includes(entityType)) {
    throw new Error(
      `Illegal entity type '${entityType}' for dynamic fields whitelist. 
      Allowed values are ${JSON.stringify(allowedEntityTypes)}`,
    )
  }
  const idList = storeGet(STORE_KEY_ID_LIST)
  const res = await beAccountSettingsGetUserSetting(
    idList,
    `whiteListDynamicField-${entityType}-${id}`,
  )
  return res ? JSON.parse(res.DataValue) : []
}

export function setDynamicFieldsWhitelist(entityType, id, value) {
  const allowedEntityTypes = ['TPL', 'NL', 'CMP']
  if (!allowedEntityTypes.includes(entityType)) {
    throw new Error(
      `Illegal entity type '${entityType}' for dynamic fields whitelist. 
      Allowed values are ${JSON.stringify(allowedEntityTypes)}`,
    )
  }
  const idList = storeGet(STORE_KEY_ID_LIST)

  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)

  if (loginType === LOGIN_TYPE_WEBLOGIN) {
    beAccountSettingsUpsertUserSettings(
      idList,
      `whiteListDynamicField-${entityType}-${id}`,
      value,
    )
  }

  pendoTrack('Editor bee - dynamic field - warning click Don’t show anymore', {
    IdMessage: id,
    Value: value,
    Mode: 'Editing',
    EntityType: entityType,
    Id: id,
  })
}

export async function getHTMLFromStructure(jsonStructure) {
  const { access_token: token } = await beBeeServiceApiAuthorizeBee('message')
  const html = await beeParserApiGetHTMLFromStructure(token, jsonStructure)
  return html
}

/****************************************************************************/

export async function createMessage(subject, structure, content) {
  const checkLiquid = evalCondition(
    'NOT co:ADVPERSONALIZATION AND co:PERSONALIZATION',
  )
  const idPersonalContent = null
  const idList = storeGet(STORE_KEY_ID_LIST)

  const message = {
    Subject: subject,
    PreHeader: '',
    Notes: '',
    Structure: structure,
    Content: content,
    IdList: idList,
    Embed: false,
    IsConfirmation: false,
    IsArchived: false,
    ShowOnline: false,
    UseDynamicField: true,
    Tags: [],
    Fields: [],
    TrackingInfo: {
      Enabled: true,
      Protocols: ['http:', 'https:', 'ftp:', 'news:'],
      CustomParams: '',
    },
  }

  const result = await beMessApiCreateMessage(message, {
    checkLiquid,
    idPersonalContent,
  })

  return result
}

export async function updateAutosave(
  idMessage,
  { content, subject, structure },
) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const autosaveData = {
    Text: content || '',
    Subject: subject || '',
    Notes: '',
    PreHeader: '',
    Structure: structure,
  }

  await beMessSetMessageAutoSave(idList, idMessage, autosaveData)
}

export async function validateMessageType(idMessage, messageType) {
  if (
    [MESSAGE_STR_TYPE_WELCOME, MESSAGE_STR_TYPE_CONFIRMATION].includes(
      messageType,
    )
  ) {
    const result = await beMessCheckSetMessageTypes(idMessage, messageType)

    return result
  }

  return true
}
export async function validateMessageForNotification(
  idMessage,
  messageContent,
) {
  const result = await beMessCheckCompliantHtmlMessageType(
    idMessage,
    messageContent,
  )
  return result
}
export async function updateBeeMessage(idMessage, { Content, Structure }) {
  const checkLiquid = evalCondition(
    'NOT co:ADVPERSONALIZATION AND co:PERSONALIZATION',
  )
  const idPersonalContent = null

  const prev = await beMessGetMessageDetails(idMessage)

  const result = await beMessApiUpdateMessage(
    idMessage,
    {
      ...prev,
      Content,
      Structure,
    },
    {
      checkLiquid,
      idPersonalContent,
    },
  )

  return result
}

export async function getRequiresUpdateWelcomeSeries(messageType) {
  if (messageType === MESSAGE_STR_TYPE_WELCOME) {
    const idList = Number.parseInt(storeGet(STORE_KEY_ID_LIST))

    const data = {
      Status: WORKFLOW_STR_STATUS_ALL,
      Type: WORKFLOW_STR_TYPE_WELCOME_SERIES,
    }

    const result = await beAutomationApiSearchWorkflowByTypeAndStatus(
      idList,
      data,
    )

    return result.Items.length > 0
  }

  return false
}

export async function updateWelcomeNotification(
  idMessage,
  messageType,
  requiresUpdateWelcomeSeries,
) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  if (messageType === MESSAGE_STR_TYPE_WELCOME) {
    await BeListApiSetWelcomeMessage(idList, true)
  }
  await beMessApiSetActiveMessageOfType(idList, idMessage, messageType)

  if (requiresUpdateWelcomeSeries) {
    await beAutomationApiUpdateWelcomeSeries(idList, idMessage)
  }
}

export async function getBeeTemplateDetails(idTemplate, mode) {
  const result = await (mode === 'local'
    ? beMessGetBeeTemplateDetails(idTemplate)
    : beMessGetBeeCentralizedEmailTemplateDetails(idTemplate))
  return result
}

export async function generatePreview(idMessage, params) {
  const res = await beEmailRenderingApiGeneratePreview(idMessage, params)
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)

  const transformedContent = transformations(res.Content)
    .replaceHref({
      '#': ['http://', `http://${Domain}`, `http://${Domain}/`],
    })
    .disablePointerEvents('a[href^="["]')
    .disablePointerEvents('a[href="#"]')
    .disablePointerEvents('a[href=""]')
    .secureBlankTargets()
    .getHtml()

  return {
    ...res,
    Content: transformedContent,
  }
}

export async function getListActivation() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const hasPersonalization = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION',
  )

  const result = hasPersonalization
    ? await bePersonalizationApiGetListActivation(idList)
    : { Items: [] }

  return result
}
export async function getMessageActivation(idMessage) {
  const hasPersonalization = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION',
  )

  const result = hasPersonalization
    ? await bePersonalizationApiGetMessageActivation(idMessage)
    : { Items: [] }

  return result
}

export const getRecipient = beRecipientGetRecipient

export async function getMessageDynamicContents(idMessage) {
  const results =
    await beEmailMessageApiListDynamicContentByIdMessage(idMessage)

  return results.map(({ Id, Name }) => ({ id: Id, name: Name }))
}

export async function getGroups(searchBy, exact = false) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: 0,
    searchBy,
    searchType: exact
      ? GROUPS_SEARCH_TYPE_EQUALTO
      : GROUPS_SEARCH_TYPE_ECONTAINS,
  })
  return Items.map(({ Id, Name, Notes }) => ({
    label: `${Id} - ${Name}${Notes ? ' (' + Notes + ')' : ''}`,
    value: Id,
  }))
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false,
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' }),
    },
    ...categories.Items,
  ]

  const filters = await beFiltersGetListOfFilters(idList, {
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false,
    hidden,
  })

  const allFilters = filters.Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id),
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name,
    })),
  }

  return result
}

export async function searchRecipients(search, dynamicFields) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const { pageNumber, pageSize, orderDescending } = search

  const searchParams = {
    channel: CHANNEL_TYPE_EMAIL,
    status: [SUBSCRIPTION_TYPE_SUBSCRIBED],
    pageSize,
    pageNumber,
    orderDescending,
    excludeFields: false,
  }

  const searchConditions = getSearchConditions(search)

  const apiParams = new Map()
  apiParams.set('idList', idList)
  apiParams.set('searchParams', searchParams)
  apiParams.set('searchConditions', searchConditions)

  const res = await beRecipientSearchForRecipients(...apiParams.values())

  return {
    ...res,
    Items: res.Items.map((item) => {
      const fields = new Map().set('Email', item.Email)

      const fieldsEntries = item.Fields.filter(({ Id }) =>
        dynamicFields.find((df) => df.Id === Id),
      ).map((dynamicField) => [dynamicField.Id, dynamicField.Value])

      const allFields = fieldsEntries.reduce((acc, [fieldId, fieldValue]) => {
        const dynamicField = dynamicFields.find(
          (dynamicField) => fieldId === dynamicField.Id,
        )
        return acc.set(dynamicField.Description, fieldValue)
      }, fields)

      return {
        id: item.Id,
        fields: allFields,
        fieldsEntries,
      }
    }),
  }
}

const getSearchConditions = (search) => {
  const {
    channel,
    email,
    includeGroups,
    applyFilters,
    applyFiltersOr,
    optOutTypeEmail,
    optOutTypeSms,
    optOutMessage,
  } = search

  return {
    IncludeGroups: [...includeGroups],
    MatchingFilters: applyFilters.length
      ? {
          Condition: applyFiltersOr,
          Filters: [...applyFilters],
        }
      : undefined,
    UnsubscriptionType:
      channel === 'email' ? `${optOutTypeEmail}` : `${optOutTypeSms}`,
    UnsubscriptionMessage: channel === 'email' ? optOutMessage : undefined,
    Email: email,
    EmailMatchType: 'CONTAINS',
  }
}

export async function getPreviewReferenceRecipient(idList) {
  const result = await beAccountSettingsGetUserSetting(
    idList,
    'previewReferenceRecipient',
  )

  if (result && result.DataValue) {
    return JSON.parse(result.DataValue)
  }

  return {}
}

export async function getUsedTokens() {
  return beBeeServiceGetUsedTokens()
}

export async function storeUsedTokens(value) {
  return beBeeServiceStoreUsedTokens(value)
}

export const saveAndExit = async ({ id, messageType, onSuccess }) => {
  await deleteConcurrentAccess(id)
  await deleteAutosave(id)

  typeof onSuccess === 'function' && onSuccess(id, messageType)
}

export const checkTemplatesLimitsExceeded = async () => {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const [{ MaxTemplates }, { TotalItems }] = await Promise.all([
    beAccountSettimgsApiGetAccountLimits(),
    beMessGetBeeTemplates({
      idList,
      filterBy: '',
      orderBy: 'Id DESC',
      pageNum: 1,
      pageSize: 1,
    }),
  ])

  return MaxTemplates > 0 && TotalItems >= MaxTemplates
}
